import { render } from "./TheAlarmsContainer.vue?vue&type=template&id=44b45827"
import script from "./TheAlarmsContainer.vue?vue&type=script&lang=js"
export * from "./TheAlarmsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__